import * as React from 'react';
import type { BlockedProductListEntry, BlockedProductIndicators } from 'contracts/blocked-products';
import { api, applyQueryString } from 'services/api';
import type { Filters } from 'hooks/store/blocked-products';

type FetchBlockedProductsResponse = {
  blockedProducts: BlockedProductListEntry[];
  indicators: BlockedProductIndicators;
}

type FetchParams = {
  filters?: Filters;
}

export const useFetchBlockedProducts = () => {
  const fetchBlockedProducts = React.useCallback(async (params: FetchParams): Promise<FetchBlockedProductsResponse> => {
    const filters = params?.filters ?? {};
    const preparedFilters = prepareQueryObject(filters);

    const url = applyQueryString('/inventory/blocked-products', preparedFilters);
    const { data } = await api.get<FetchBlockedProductsResponse>(url);

    return data;
  }, []);

  return {
    fetchBlockedProducts,
  };
};

const prepareQueryObject = (filters: Filters) => {
  type MyFilters = Record<string, unknown>;

  if (filters.totalValue) {
    let [from, to] = filters.totalValue.split(':');
    const fromNumber = Number(from);
    const toNumber = Number(to);
    if (!Number.isNaN(fromNumber)) {
      (filters as MyFilters)['totalValueFrom'] = fromNumber;
    }
    if (!Number.isNaN(toNumber)) {
      (filters as MyFilters)['totalValueTo'] = toNumber;
    }
    delete (filters as MyFilters)['totalValue'];
  }

  if (filters.shelfLifeExpirationDate) {
    const rangeValue = filters.shelfLifeExpirationDate;
    if (rangeValue?.startsWith('from')) {
      (filters as MyFilters)['shelfLifeExpirationDateFrom'] = rangeValue.split(':')[1];
    }
    if (rangeValue?.startsWith('to')) {
      (filters as MyFilters)['shelfLifeExpirationDateTo'] = rangeValue.split(':')[1];
    }
    delete (filters as MyFilters)['shelfLifeExpirationDate'];
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (!value || (Array.isArray(value) && !value?.length)) {
      delete (filters as MyFilters)[key];
    }
  });

  return filters;
};